var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWatchlistBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "-421 222 117 117"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-362.5 222c-32.3 0-58.5 26.2-58.5 58.5s26.2 58.5 58.5 58.5 58.5-26.2 58.5-58.5-26.2-58.5-58.5-58.5",
    fill: "#fff",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-382 300.1h-5.6c-.7 0-1.2.6-1.2 1.2s.6 1.2 1.2 1.2h5.6v5.6c0 .7.6 1.2 1.2 1.2.7 0 1.2-.6 1.2-1.2v-5.6h5.6c.7 0 1.2-.6 1.2-1.2s-.6-1.2-1.2-1.2h-5.6v-5.6c0-.7-.6-1.2-1.2-1.2-.7 0-1.2.6-1.2 1.2v5.6zm52.9-38.7l-9.9 39.5v6.2c0 1.4-1.1 2.5-2.4 2.5h-24.8c.5-.8.9-1.6 1.2-2.5h23.6v-45h-44.8v24.4c-.8.3-1.7.6-2.4 1V262c0-1.4 1.1-2.5 2.4-2.5h6.3l2.5-10.1c.4-1.6 2-2.6 3.7-2.2l42.3 10.5c1.7.4 2.7 2 2.3 3.7zm-50.9 21.8c-.7 0-1.2.6-1.2 1.2 0 .7.6 1.2 1.2 1.2h32.3c.7 0 1.2-.6 1.2-1.2 0-.7-.6-1.2-1.2-1.2H-380zm0-11.7c-.7 0-1.2.6-1.2 1.2 0 .7.6 1.2 1.2 1.2h32.3c.7 0 1.2-.6 1.2-1.2 0-.7-.6-1.2-1.2-1.2H-380zm33.5 24.7c0 .7-.6 1.2-1.2 1.2h-16.9c-.2-.9-.5-1.7-.9-2.5h17.7c.8.1 1.3.7 1.3 1.3zm-34.3 18.8c-7.8 0-14.2-6.1-14.2-13.7 0-7.5 6.4-13.7 14.2-13.7s14.2 6.1 14.2 13.7c.1 7.6-6.3 13.7-14.2 13.7zm0-24.7c-6.4 0-11.7 5-11.7 11.1 0 6.2 5.3 11.1 11.7 11.1 6.4 0 11.7-5 11.7-11.1s-5.1-11.1-11.7-11.1z",
    fill: "#304256"
  })));
}

export default SvgWatchlistBig;